import { render, staticRenderFns } from "./send.vue?vue&type=template&id=687b0a0e&"
import script from "./send.vue?vue&type=script&lang=js&"
export * from "./send.vue?vue&type=script&lang=js&"
import style0 from "./send.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports